export default __webpack_public_path__ + "static/media/6_sap.29e0f3e2.svg";